import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ProcedureType} from "../../models/procedure";

@Component({
  selector: 'app-authoring-slot',
  templateUrl: './authoring-slot.component.html',
  styleUrls: ['./authoring-slot.component.scss']
})
export class AuthoringSlotComponent implements OnInit {

  @Input()
  title: string;

  @Input()
  task: number;

  @Input()
  procedureTypes: ProcedureType[];

  @Input()
  isEmpty: boolean;

  @Input()
  canDelete: boolean;

  @Output()
  onEdit = new EventEmitter();

  @Output()
  onRemove = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  getAuthoringIcon(type: ProcedureType) {
    switch (type) {
      case ProcedureType.VIDEO:
        return 'play_circle';
      case ProcedureType.MIXED_REALITY:
        return '3d_rotation';
      case ProcedureType.TEXT:
        return 'format_list_numbered';
    }
  }

  getAuthoringIcons() {
    return this.procedureTypes.map(this.getAuthoringIcon);
  }

}
